import TBody from './tbody';

export default TBody;